module.exports = __webpack_public_path__ + "static/media/3.6 KC Tribunj 6-14.08.2025.4ebdfc3d.jpg";